export const apis = [];

export const options = [
  { key: 1, text: "Successful", value: 1 },
  { key: 2, text: "Unsuccessful", value: 2 },
];

export const results = [
  {
    id: 1,
    test: "Send name enquire request",
    status: "passed",
    request: "",
    response: "",
  },
  {
    id: 2,
    test: "Send MA of 1000 for a specific mandate number",
    status: "passed",
    request: "",
    response: "",
  },
  {
    id: 3,
    test:
      "SEND BE USING ANY VALID AUTHORIZATION CODE WHICH WAS INITIATLLY SUBMITTEDDURING MANDATE ADVICE ABOVE E.G. REF/001/102500",
    status: "passed",
    request: "",
    response: "",
  },
  {
    id: 4,
    test:
      "SEND BALANCE ENQUIRY (BE) REQUEST TO CONFIRM THE AVAILABLE BALANCE ON THEACCOUNTEXPECTED RESPONSE​: BALANCE IS RETURNED, NOTE IT DOWN",
    status: "passed",
    request: "",
    response: "",
  },
  {
    id: 5,
    test:
      "SEND FT CREDIT OF A SPECIFIC AMOUNT TO THE ACCOUNT E.G. 1000.00EXPECTED RESPONSE​: RESPONSE CODE 00 – SUCCESSFUL",
    status: "passed",
    request: "",
    response: "",
  },
  {
    id: 6,
    test: "Send name enquire request",
    status: "failed",
    request:
      "{ “success”: true, “payload”: [ { “id”: 1, “success”: false, “error_code”: “AD_BAD_VALIDATION”, “message”: [ “ERROR: Error creating campaign_budget, field improperly formatted decimal” ] }, { “id”: 30, “success”: true, “message”: “campaign updated successfully” } ], “errors”: [ “ERROR: campaign update: 1 updated successfully, 1 with errors” ] }",
    response:
      "{ “success”: true, “payload”: [ { “id”: 1, “success”: false, “error_code”: “AD_BAD_VALIDATION”, “message”: [ “ERROR: Error creating campaign_budget, field improperly formatted decimal” ] }, { “id”: 30, “success”: true, “message”: “campaign updated successfully” } ], “errors”: [ “ERROR: campaign update: 1 updated successfully, 1 with errors” ] }",
  },
  {
    id: 7,
    test: "Send name enquire request",
    status: "failed",
    request:
      "{ “success”: true, “payload”: [ { “id”: 1, “success”: false, “error_code”: “AD_BAD_VALIDATION”, “message”: [ “ERROR: Error creating campaign_budget, field improperly formatted decimal” ] }, { “id”: 30, “success”: true, “message”: “campaign updated successfully” } ], “errors”: [ “ERROR: campaign update: 1 updated successfully, 1 with errors” ] }",
    response:
      "{ “success”: true, “payload”: [ { “id”: 1, “success”: false, “error_code”: “AD_BAD_VALIDATION”, “message”: [ “ERROR: Error creating campaign_budget, field improperly formatted decimal” ] }, { “id”: 30, “success”: true, “message”: “campaign updated successfully” } ], “errors”: [ “ERROR: campaign update: 1 updated successfully, 1 with errors” ] }",
  },
];

export default { apis, options, results };
